import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../components/home/header";
import Footer from "../components/home/footer";

const BuyNowCheckout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Product from Buy Now
  const product = location.state?.product;

  // 🔐 LOGIN CHECK
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user || !user.email) {
      navigate("/login");
    }
  }, [navigate]);

  // ❌ PREVENT DIRECT ACCESS
  useEffect(() => {
    if (!product) {
      navigate("/");
    }
  }, [product, navigate]);

  // 📦 ADDRESS STATE
  const [form, setForm] = useState({
    name: "",
    phone: "",
    address: "",
    city: "",
    country: "",
    pincode: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // 💰 PRICE CALCULATION
  const subtotal = product?.totalPrice || 0;
  const delivery = subtotal > 500 ? 0 : 50;
  const finalTotal = subtotal + delivery;

  // 🚀 PLACE ORDER
const handlePlaceOrder = async () => {
  if (Object.values(form).some((v) => v.trim() === "")) {
    alert("Please fill all address fields");
    return;
  }

  try {
    // 1️⃣ CREATE ORDER (OPTIONAL BUT RECOMMENDED)
    const orderRes = await fetch("https://ankit1.jaskart.com/api/orders/create", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        user: JSON.parse(localStorage.getItem("user")),
        product,
        address: form,
        amount: Number(finalTotal),
      }),
    });

    const orderData = await orderRes.json();
    
    console.log(orderData);
    
    if (orderData.success && orderData.checkoutPageUrl) {
      window.location.href = orderData.checkoutPageUrl;
    } else {
      alert("Payment initiation failed");
    }

    

  } catch (error) {
    console.error(error);
    alert("Server error");
  }
};


  return (
    <>
      <Header />

      <div className="container mt-5 mb-5 checkout-page">
        <h2 className=" text-center mb-4" style={{fontWeight:'600'}}>Checkout</h2>

        <div className="row">

          {/* LEFT - DELIVERY FORM */}
          <div className="col-md-6">
            <div className="checkout-form">
              <h3 className="mb-3">Delivery Information</h3>

              <input type="text" name="name" placeholder="Full Name" className="form-control mb-3" onChange={handleChange} />
              <input type="text" name="phone" placeholder="Phone Number" className="form-control mb-3" onChange={handleChange} />
              <input type="text" name="address" placeholder="Address" className="form-control mb-3" onChange={handleChange} />
              <input type="text" name="city" placeholder="City" className="form-control mb-3" onChange={handleChange} />
              <input type="text" name="country" placeholder="Country" className="form-control mb-3" onChange={handleChange} />
              <input type="text" name="pincode" placeholder="Pincode" className="form-control mb-4" onChange={handleChange} />

              <button
                className="place-order-btn w-100"
                onClick={handlePlaceOrder}
                style={{ boxShadow: "5px 5px gray", borderRadius: "30px",}}
              >
                Pay ₹{finalTotal}
              </button>
            </div>
          </div>

          {/* RIGHT - ORDER SUMMARY */}
          <div className="col-md-6">
            <div className="checkout-summary p-4">
              <h3>Your Order</h3>

              <div className="d-flex justify-content-between mt-3">
                <p>{product?.name} × {product?.quantity}</p>
                <p>₹{subtotal}</p>
              </div>

              <hr />

              <div className="text-end">
                <p>Subtotal: ₹{subtotal}</p>
                <p>Delivery: {delivery === 0 ? "FREE" : `₹${delivery}`}</p>
                <h5>Total: ₹{finalTotal}</h5>
              </div>
            </div>
          </div>

        </div>
      </div>

      <Footer />
    </>
  );
};

// 🎨 STYLES (MISSING IN YOUR CODE)
const btnStyle = {
  background: "none",
  borderRadius: "30px",
  border: "1px solid black",
  boxShadow: "5px 5px gray",
  fontWeight: "700",
};

const summaryStyle = {
  background: "#fff",
  borderRadius: "10px",
  boxShadow: "6px 6px gray",
};

export default BuyNowCheckout;
